import {useHistory} from "react-router-dom";
import {useSelector} from "react-redux";
import {State} from "../store/reducer";

export default (type = true) => {
    const userInfo = useSelector<State,State["userInfo"]>(state => state.userInfo)
    const history = useHistory()
    if(userInfo){
        return userInfo
    }else if(type){
        history.push('/login')
    }else{
        return null
    }
}
